import React, { Component } from "react";
import {
  getTrans,
  autoFill,
  getLocalStorage,
  makeManageTeamSkeleton,
  getOutTeamArray,
  setLocalStorage,
  getInTeamArray,
  getCaptain,
  getTransferArray,
  getLoginCookie,
  getBoostersObject,
  getAppliedBooster,
  getBoosterCaptain,
  getTeamDeadlineObj,
  googleAnalyticsEventTracking,
  getSubstitutionStatus,
  subsWarningCheck,
  getIsLateOnboardUser,
  getSubsPlayer,
  updateBusters,
  checkIsAnyVersionChanged,
} from "../../common";
import { Consume } from "../../Context/Consumer";
import {
  TransContext,
  TeamDataContext,
  PlayerListContext,
  ConstraintsContext,
  CompositionContext,
  ShowPopUpContext,
  FixturesContext,
  ShowToastContext,
  GamedaysContext,
  BoosterCardContext,
  LoginContext,
} from "../../Context/index";
import config from "../../common/config";
import { withRouter } from "react-router-dom";
import { Fragment } from "react";
import BoosterButton from "./boosterBtn";

class TeamDataHeader extends Component {
  constructor(props) {
    super(props);
    // this.autoComplete.bind(this)
    this.state = {
      isTransferSummary: false,
      isWildCardActivated: false,
      isFreeze: false,
      showWarning: false,
    };
  }

  componentDidMount() {
    let self = this;
    window.location.pathname.indexOf("transfer-summary") > -1 &&
      self.setState({ isTransferSummary: true });
    const { childRef } = this.props;
    childRef && childRef(this);
  }

  autoComplete = (showNext) => {
    // customTracking("Auto Complete", '/' + config.GAME_NAME + "/my-team/manage/");
    const { action, category, label } =
      config.trackclickEvents.autoCompleteManageTeam;
    googleAnalyticsEventTracking(action, category, label);
    if (
      this.props.TeamData.data.playerCount !=
      config.WebConfig.MAX_PLAYERS_PER_TEAM
    ) {
      let playerList = this.props.PlayerListData.data.playerList;
      let teamData = this.props.TeamData.data;
      let autoCompleteData = autoFill(
        this.props.PlayerListData.rawPlayerList.filter((plyr) => plyr.IsActive),
        teamData,
        true
      );
      if (autoCompleteData.errorObj.isAutofillError) {
        let trans = this.props.TransData.data;
        this.props.showHideToast(
          true,
          getTrans(
            trans,
            "insufficient_budget",
            "Your budget is too low to auto-complete your team"
          ),
          true,
          false,
          true
        );
        /* console.log("error"); */
      }
      this.props.TeamData.setTeamData(autoCompleteData.teamData);
    }
  };

  openMoreOptions = () => {
    this.setState({
      openMoreOptions: !this.state.openMoreOptions,
    });
  };

  resetTeam = (showNext) => {
    if (showNext) {
      let creatTeamObj = {
        constraints: this.props.ConstraintsData.data,
        formations: this.props.CompositionData.data,
        newFormationId: getLocalStorage("lastFormation")
          ? getLocalStorage("lastFormation").compId
          : this.props.CompositionData.activeComposition.compId,
        playerPos: config.playerPos,
        teamData: getLocalStorage("teamDataManage")
          ? getLocalStorage("teamDataManage")
          : {},
      };

      let teamDataSkeleton = makeManageTeamSkeleton(
        creatTeamObj.teamData,
        this.props.PlayerListData.rawPlayerList,
        this.props.CompositionData.data
      );
      //set compositions
      this.props.CompositionData.setCompositions({
        ...teamDataSkeleton.updatedFormations,
        defaultCompId: this.props.CompositionData.data.defaultCompId,
      });
      let teamData = teamDataSkeleton.teamData;
      this.props.TeamData.setTeamData(teamData);

      // customTracking('Reset team', getPageName());

      this.setState({
        openMoreOptions: false,
      });
    }
  };

  goToTransferSummary = () => {
    let self = this;
    self.props.history.push(config.BASE_DOMAIN_LANG + "transfer-summary");
  };

  openDetails = (val) => {
    this.setState({
      openInfo: val,
    });
  };

  goBack = (showNext) => {
    let self = this;
    let trans = self.props.TransData.data;

    //check modes
    let mode = self.props.FixturesData.gameMode;
    let screenMode = self.props.FixturesData.screenMode;
    if (
      mode == config.modes.transfer &&
      screenMode == config.screenMode.substitution
    ) {
      mode = config.modes.substitution;
    }

    if (mode == config.modes.transfer) {
      if (showNext) {
        self.props.showHideToast(true, "", false, true);
      } else {
        checkIsAnyVersionChanged();
        self.props.history.push(config.BASE_DOMAIN_LANG + "my-team");
      }
      let boosters = getBoostersObject(
        self.props.CompositionData.boostersList,
        self.props.Gamedays?.selectedTeam?.Boosters
      );
      let activeBooster = getAppliedBooster(
        boosters,
        +self.props.FixturesData.currMatchDay.GamedayId
      );
      if (
        config.enumBoosterTypes.two.indexOf(activeBooster?.BoosterId + "") >
          -1 &&
        self.props.BoosterCardData.isTempLimitlessBooster
      ) {
        self.props.BoosterCardData.setObjShowHideBooster({
          isShowRemoveBoosterToast: true,
          removedBooster: activeBooster?.BoosterId,
        });
        self.child &&
          self.child.removeBooster &&
          self.child.removeBooster(activeBooster);
      }
    } else if (mode == config.modes.substitution) {
      //checks subs

      let showPopUp = false;
      if (showNext) {
        showPopUp = true;
      }

      if (showPopUp) {
        self.props.showHideToast(true, "", false, true);
      } else {
        return self.props.history.goBack();
      }
    }
  };

  makeSubsPostcall = () => {
    let self = this;
    self.setState({ showWarning: false });
    const transData = self.props.TransData.data;
    let { showHideToast } = self.props;
    let captainPlayer = getCaptain(self.props.TeamData.data);
    let transferArray = getTransferArray(self.props.TeamData.data, true);
    let boosterCaptainPlayerId = self.props.TeamData.data.boosterCaptainId;
    let boosterCaptainPlayer = getBoosterCaptain(
      self.props.TeamData.data,
      boosterCaptainPlayerId
    );
    let loginCookie = getLoginCookie();
    let params = {
      optType: config.optType,
      platform: 1,
      gamedayId: self.props.FixturesData.currMatchDay.GamedayId,
      phaseId: self.props.FixturesData.currMatchDay.PhaseId,
      teamName: loginCookie.TeamName,
      captainId: captainPlayer.id,
      gdCompId:
        self.props.CompositionData.data[config.WebConfig.MAX_FORMATION_COMP_ID]
          .CompId,
      mdCompId: self.props.TeamData.data.CompId,
      players: transferArray,
      bsCaptainId: boosterCaptainPlayer?.details?.Id
        ? boosterCaptainPlayerId
        : null,
    };
    self.props.TeamData.makeSubsPostcall(
      params,
      (resp) => {
        // console.log(resp);
        showHideToast(
          true,
          getTrans(
            transData,
            "substitution_success_msg",
            "Substitution completed successfully"
          ),
          false
        );
        // setMakeRedirect(true);
        let params = {
          optType: config.optType,
          gamedayId: self.props.FixturesData.currMatchDay.GamedayId,
          phaseId: self.props.FixturesData.currMatchDay.PhaseId,
          language: config.language,
        };
        self.props.Gamedays.getSelectedTeam(
          params,
          (response) => {
            let teamDataSkeleton = makeManageTeamSkeleton(
              response.Data.Value,
              self.props.PlayerListData.rawPlayerList,
              self.props.CompositionData.data
            );
            self.props.TeamData.setTeamData({
              ...teamDataSkeleton.teamData,
            });
            setLocalStorage("teamData", teamDataSkeleton.teamData);
          },
          () => {}
        );
        self.setState({
          isFreeze: false,
        });
      },
      (resp) => {
        let retVal = resp.RetVal;
        if (retVal === 6) {
          showHideToast(
            true,
            getTrans(
              transData,
              "team_already_created_err",
              "Team already created"
            ),
            true
          );
        } else {
          //showHideToast(true, `retVal Error ${retVal}`, true);
          showHideToast(true, `The match is live`, true);
          self.resetTeam(true);
        }
      }
    );
  };

  saveTransfers = (mode) => {
    const { action, category, label } =
      config.trackclickEvents.saveTeamManageTeam;
    googleAnalyticsEventTracking(action, category, label);
    let self = this;
    const transData = this.props.TransData.data;
    const { setMakeRedirect, showHideToast, BoosterCardData } = self.props;
    let captainPlayer = getCaptain(self.props.TeamData.data);
    let transferArray = getTransferArray(self.props.TeamData.data, true);
    let boosterCaptainPlayerId = self.props.TeamData.data.boosterCaptainId;
    let boosterCaptainPlayer = getBoosterCaptain(
      self.props.TeamData.data,
      boosterCaptainPlayerId
    );
    let loginCookie = getLoginCookie();
    let params = {
      optType: config.optType,
      platform: 1,
      gamedayId: self.props.FixturesData.currMatchDay.GamedayId,
      phaseId: self.props.FixturesData.currMatchDay.PhaseId,
      teamName: loginCookie.TeamName,
      captainId: captainPlayer.id,
      gdCompId:
        self.props.CompositionData.data[config.WebConfig.MAX_FORMATION_COMP_ID]
          .CompId,
      mdCompId: self.props.TeamData.data.CompId,
      players: transferArray,
      bsCaptainId: boosterCaptainPlayer?.details?.Id
        ? boosterCaptainPlayerId
        : null,
    };
    self.setState({
      isFreeze: true,
    });

    if (mode === config.modes.transfer) {
      let is2xCapBooster = false;
      let boosters = getBoostersObject(
        self.props.CompositionData.boostersList,
        self.props.Gamedays?.selectedTeam?.Boosters
      );
      let activeBooster = getAppliedBooster(
        boosters,
        +self.props.FixturesData.currMatchDay.GamedayId
      );
      if (activeBooster?.BoosterId === config.boosterCaptain) {
        is2xCapBooster = true;
        params.bsAutoDel = boosterCaptainPlayer?.details?.Id ? 0 : 1;
      }
      params.isWildCard =
        this.props.FixturesData.currMatchDay.GamedayId ===
        self.props.TeamData.data.UserWildCardGameday
          ? 1
          : 0;
      //params.isWildCard = self.props.TeamData.data.IsWildCardTaken == 1 ? 1 : 0;
      if (
        config.enumBoosterTypes.two.indexOf(activeBooster?.BoosterId + "") >
          -1 &&
        BoosterCardData.isTempLimitlessBooster
      ) {
        params.boosterId = activeBooster?.BoosterId;
        params.isWildCard = 0;
        delete params.optType;
        delete params.teamName;
        delete params.bsCaptainId;
      }
      (config.enumBoosterTypes.two.indexOf(activeBooster?.BoosterId + "") >
        -1 && BoosterCardData.isTempLimitlessBooster
        ? BoosterCardData.submitLimitlessBooster
        : self.props.TeamData.makePostTeamTransfers)(
        params,
        (resp) => {
          // setMakeRedirect(true);
          if (BoosterCardData.isTempLimitlessBooster) {
            self.props.BoosterCardData.setObjShowHideBooster({
              isTransferBoosterApplied: true,
            });
          }
          let params = {
            optType: config.optType,
            gamedayId: self.props.FixturesData.currMatchDay.GamedayId,
            phaseId: self.props.FixturesData.currMatchDay.PhaseId,
            language: config.language,
          };
          updateBusters("/team");
          showHideToast(
            true,
            getTrans(
              transData,
              "transfer_success_msg",
              "Transfers completed successfully"
            ),
            false
          );
          is2xCapBooster &&
            !boosterCaptainPlayer?.details?.Id &&
            self.props.BoosterCardData.setObjShowHideBooster({
              isShowRemoveBoosterToast: true,
            });

          self.getTeamCall(params);
          self.setState({
            isFreeze: false,
          });
        },
        (resp) => {
          if (resp) {
            let retVal = resp.RetVal;
            if (retVal === 6) {
              showHideToast(
                true,
                getTrans(
                  transData,
                  "team_already_created_err",
                  "Team already created"
                ),
                true
              );
            } else {
              //showHideToast(true, `retVal Error ${retVal}`, true);
              showHideToast(true, `The match is live`, true);
              self.resetTeam(true);
            }
          }
        }
      );
    } else if (mode === config.modes.substitution) {
      let showWarning = subsWarningCheck(this.props.TeamData.data);
      if (showWarning) {
        self.setState({ showWarning: true });
      } else {
        self.makeSubsPostcall(params);
      }
    }
  };

  getTeamCall = (params) => {
    let self = this;
    self.props.Gamedays.getSelectedTeam(
      params,
      (response) => {
        let teamDataSkeleton = makeManageTeamSkeleton(
          response.Data.Value,
          self.props.PlayerListData.rawPlayerList,
          self.props.CompositionData.data
        );
        self.props.TeamData.setTeamData({
          ...teamDataSkeleton.teamData,
        });
        setLocalStorage("teamData", teamDataSkeleton.teamData);
      },
      () => {}
    );
  };

  activateWildcard = () => {
    let self = this;
    let teamDataT = { ...self.props.TeamData.data };

    self.setState(
      {
        isWildCardActivated: true,
      },
      () => {
        teamDataT.tempWildcardActivated = true;

        teamDataT.IsWildCardTaken =
          self.state.isWildCardActivated && teamDataT.IsWildCardTaken === 1
            ? 0
            : 1;
        teamDataT.UserWildCardGameday =
          self.state.isWildCardActivated && teamDataT.IsWildCardTaken === 1
            ? self.props.FixturesData.currMatchDay.GamedayId
            : 0;
        self.props.TeamData.setTeamData(teamDataT);
      }
    );
  };

  render() {
    let self = this;
    let transData = this.props.TransData.data;
    let playerCount = this.props.TeamData.data.playerCount;
    let budget = this.props.TeamData.data.budget;
    let currMatchDay = this.props.FixturesData.currMatchDay;
    let showNext = false;
    let buttonHide = false;
    let subsCount = 0;
    //check modes
    let mode = this.props.mode;
    let teamData = this.props.TeamData.data;
    let screenMode = this.props.FixturesData.screenMode;
    let boosters = getBoostersObject(
      self.props.CompositionData.boostersList,
      self.props.Gamedays?.selectedTeam?.Boosters
    );
    let activeBooster = getAppliedBooster(
      boosters,
      +self.props.FixturesData.currMatchDay.GamedayId
    );
    if (
      mode == config.modes.transfer &&
      screenMode == config.screenMode.substitution
    ) {
      mode = config.modes.substitution;
    }
    if (self.state.isTransferSummary) {
      mode = config.modes.transfer;
    }
    let showInfoHeader = true;
    let title = getTrans(transData, "transfers", "Transfers");
    let buttonTitle = getTrans(transData, "next", "Next");
    const transferOut = getOutTeamArray(
      this.props.TeamData.data,
      this.props.TeamData.manageTeamRawData
    );
    let showDiscardChangesPopup =
      (transferOut.length > 0 || playerCount < config.MAX_PLAYERS_PER_TEAM) &&
      playerCount == config.WebConfig.MAX_PLAYERS_PER_TEAM &&
      (this.props.TeamData.data.budget >= 0 ||
        activeBooster?.BoosterId === config.unlimitedBudgetBooster);
    if (showDiscardChangesPopup) {
      showNext = true;
    }

    let showReset =
      playerCount < config.WebConfig.MAX_PLAYERS_PER_TEAM || showNext;
    if (!showNext && this.props.TeamData.data.budget < 0) {
      showReset = true;
    }

    let matchTime = "";
    let matchDate = currMatchDay?.match && currMatchDay.match[0]?.Deadline;
    let displayDate = "";
    if (matchDate) {
      displayDate = getTeamDeadlineObj(
        transData,
        config.WebConfig.OffSet,
        matchDate
      );
      matchTime = getTeamDeadlineObj(
        transData,
        config.WebConfig.OffSet,
        matchDate
      ).matchTime;
    }

    let showAutoFill =
      this.props.TeamData &&
      this.props.TeamData.data &&
      this.props.TeamData.data.playerCount <
        config.WebConfig.MAX_PLAYERS_PER_TEAM &&
      this.props.TeamData.data.budget > 0;

    let transferredIn = [];
    if (mode == config.modes.transfer) {
      transferredIn = getInTeamArray(
        this.props.TeamData.data,
        this.props.TeamData.manageTeamRawData
      );
    }
    if (mode == config.modes.substitution) {
      showInfoHeader = false;
      title = getTrans(transData, "Substitution", "Substitution");
      buttonTitle = getTrans(transData, "Confirm", "Confirm");
      let subStatus = getSubstitutionStatus(
        this.props.TeamData.manageTeamRawData,
        this.props.TeamData.data
      );
      let isSubstituted = subStatus.substituted;
      let subCount = subStatus.count;
      subsCount = subStatus.count;
      let isSubInit = this.props.TeamData.data.substitutionInitiated;
      showNext = false;
      if (isSubstituted && !isSubInit) {
        showNext = true;
        title =
          subCount +
          " " +
          getTrans(transData, "Substitution_made", "Substitution made");
        if (subCount > 1) {
          title =
            subCount +
            " " +
            getTrans(transData, "Substitutions_made", "Substitutions made");
        }
      } else if (isSubInit) {
        title = getTrans(transData, "pickareplacement", "Pick a replacement");
      } else {
        title = getTrans(transData, "pickTosubs", "Pick to substitute");
      }

      if (this.props.TeamData.data.oldCaptainId) {
        if (
          this.props.TeamData.data.oldCaptainId !=
          this.props.TeamData.data.captainID
        ) {
          showNext = true;
        }
      }
    }
    let sWildCardClass = "si-disabled";
    let sWildCardText = getTrans(transData, "wildcard", "Wildcard");
    let isWildcardEnable = false;
    if (
      teamData.SubstitutionsLeft < transferredIn?.length &&
      !teamData.IsWildCardTaken
    ) {
      sWildCardText = getTrans(transData, "wildcard", "Wildcard");
      sWildCardClass = "";
      isWildcardEnable = true;
    }
    if (teamData.IsWildCardTaken) {
      if (currMatchDay.GamedayId === teamData.UserWildCardGameday) {
        sWildCardText = getTrans(
          transData,
          "wildcard_active",
          "Wildcard Active"
        );
        sWildCardClass = "si-active";
      } else {
        sWildCardText = getTrans(transData, "wildcard_used", "Wildcard Used");
        sWildCardClass = "si-disabled";
      }
    }

    if (activeBooster?.BoosterId) {
      sWildCardText = getTrans(transData, "wildcard", "Wildcard");
      sWildCardClass = "si-disabled";
    }

    let propsBoosterButton = {
      showHideBoosterPopup: self.props.showHideBoosterPopup,
      showHideToast: self.props.showHideToast,
      currMatchDay,
      mode,
      isManageScreen: true,
      setInitialData: self.props.setInitialData && self.props.setInitialData,
      isTransferSummaryScreen: self.state.isTransferSummary,
    };
    let dirhamText =
      config.language === config.lang.English ? (
        activeBooster?.BoosterId === config.unlimitedBudgetBooster ? (
          <i className="uae-infinite"></i>
        ) : (
          getTrans(transData, "AED", "AED") +
          " " +
          Number(budget) +
          getTrans(transData, "M", "M")
        )
      ) : activeBooster?.BoosterId === config.unlimitedBudgetBooster ? (
        <i className="uae-infinite"></i>
      ) : (
        Number(budget) +
        getTrans(transData, "M", "M") +
        " " +
        getTrans(transData, "AED", "AED")
      );

    return self.state.isTransferSummary ? (
      <div className="si-cmo__header si-borBot">
        <div className="si-cmo__header-lft si-cmo__header-lft--sm">
          {currMatchDay.match[0]?.IsTbc == "0" && (
            <p>
              {getTrans(
                transData,
                "tacticalChanges",
                "Tactical changes are available until:"
              )}{" "}
              <br />
              {displayDate.dayInt} {displayDate.monthLong} {matchTime}
            </p>
          )}
        </div>
        {!config.isMobile && (
          <>
            <div className="si-cmo__header-CTAs">
              {activeBooster?.BoosterId && !config.isMobile ? (
                <BoosterButton
                  {...propsBoosterButton}
                  childRef={(ref) => (this.child = ref)}
                />
              ) : (
                mode === config.modes.transfer &&
                teamData.IsAccounting !== 0 && (
                  <div
                    className={
                      "si-btn si-btn__white si-btn__white--outline si-hide--mob " +
                      sWildCardClass
                    }
                    onClick={() =>
                      !teamData.IsWildCardTaken && self.activateWildcard()
                    }
                  >
                    <span>{sWildCardText}</span>
                    {teamData.IsWildCardTaken &&
                    teamData.tempWildcardActivated ? (
                      <i
                        className="uae-close"
                        onClick={() => {
                          teamData.IsWildCardTaken && self.activateWildcard();
                        }}
                      ></i>
                    ) : null}
                  </div>
                )
              )}
              <div
                className={
                  "si-btn si-btn__primary si-hide--mob " +
                  (activeBooster?.BoosterId !== config.unlimitedBudgetBooster &&
                  budget < 0
                    ? "si-disabled"
                    : "")
                }
                onClick={() => !self.state.isFreeze && this.saveTransfers(mode)}
              >
                <span>
                  {getTrans(
                    transData,
                    "confirm_transfers",
                    "Confirm Transfers"
                  )}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    ) : (
      <>
        <div className="si-cmo__header-lft">
          {mode === config.modes.transfer ? (
            <div className="si-cmo__legends">
              <ul>
                <li>
                  <span>
                    {getTrans(
                      transData,
                      "available_budget",
                      "Available Budget"
                    )}
                    :{" "}
                    <em
                      className={
                        activeBooster?.BoosterId !==
                          config.unlimitedBudgetBooster && budget < 0
                          ? " si-negativeNum"
                          : ""
                      }
                    >
                      {dirhamText}
                    </em>
                  </span>
                  <span>
                    {transferredIn.length > 0
                      ? getTrans(transData, "transfers_made", "Transfers Made")
                      : getTrans(
                          transData,
                          "transfers_available",
                          "Transfers Available"
                        )}
                    :{" "}
                    <em>
                      {transferredIn.length > 0 ? (
                        transferredIn.length
                      ) : teamData.IsAccounting === 0 ||
                        (((teamData.IsWildCardTaken === 1 &&
                          teamData.UserWildCardGameday ===
                            currMatchDay.GamedayId) ||
                          config.enumBoosterTypes.two.indexOf(
                            activeBooster?.BoosterId + ""
                          ) > -1) &&
                          mode === config.modes.transfer) ? (
                        <i className="uae-infinite"></i>
                      ) : teamData.SubstitutionsLeft > 0 ? (
                        teamData.SubstitutionsLeft
                      ) : (
                        0
                      )}
                    </em>
                  </span>
                </li>
              </ul>
            </div>
          ) : (
            <p>
              {getTrans(transData, "total_substitution_count", "Total Subs :")}{" "}
              {subsCount}
            </p>
          )}
        </div>
        <div className="si-cmo__header-CTAs">
          <ul>
            {mode === config.modes.transfer && teamData.IsAccounting !== 0 ? (
              <li
                className={sWildCardClass}
                onClick={() => {
                  (isWildcardEnable || teamData.tempWildcardActivated) &&
                    self.activateWildcard();
                }}
              >
                <span>{sWildCardText}</span>
              </li>
            ) : null}
            {mode === config.modes.transfer && (showAutoFill || showNext) ? (
              <li
                className={showReset ? "" : " si-disabled"}
                onClick={() => this.resetTeam(showReset)}
              >
                <span>{getTrans(transData, "reset_btn", "Reset")}</span>
              </li>
            ) : (
              <Fragment />
            )}
            {mode === config.modes.transfer && !showNext && showAutoFill ? (
              <li
                className={showAutoFill ? "" : " si-disabled"}
                onClick={() => {
                  this.autoComplete();
                }}
              >
                <span>
                  {getTrans(transData, "auto_complete_small", "Auto Complete")}
                </span>
              </li>
            ) : (
              <Fragment />
            )}
            {mode === config.modes.transfer && !showNext ? null : (
              <li
                className={showNext ? "" : " si-disabled"}
                onClick={
                  showNext
                    ? () =>
                        mode === config.modes.transfer
                          ? !self.state.isFreeze &&
                            this.goToTransferSummary(mode)
                          : !self.state.isFreeze && this.saveTransfers(mode)
                    : null
                }
              >
                <span>
                  {mode === config.modes.transfer
                    ? getTrans(transData, "next_btn", "Next")
                    : getTrans(transData, "confirm_btn", "Confirm")}
                </span>
              </li>
            )}
            {showAutoFill ||
            (showNext && mode === config.modes.transfer) ? null : (
              <li
                className={""}
                onClick={() => {
                  this.goBack(showNext);
                }}
              >
                <span>
                  {mode === config.modes.transfer
                    ? getTrans(transData, "exit_trans", "Exit Transfer")
                    : getTrans(transData, "exit_subs", "Exit Substitution")}
                </span>
              </li>
            )}
          </ul>
          {config.isMobile ? null : (
            <BoosterButton
              {...propsBoosterButton}
              childRef={(ref) => (this.child = ref)}
            />
          )}
          {self.state.showWarning ? (
            <div className="si-popup__wrap si-league__popup si-fade in">
              <div className="si-popup__container">
                <div className="si-popup__head">
                  <div
                    className="si-popup__close"
                    onClick={() => {
                      self.props.history.goBack();
                    }}
                  >
                    <div className="si-btn__adRe"></div>
                  </div>
                </div>
                <div className="si-popup__body">
                  <div className="si-popup__para">
                    <span>
                      {getTrans(
                        transData,
                        "change_subs_info",
                        "You're about to sub off a player who played yesterday. Once you confirm, you'll lose any points they scored and won't be able to undo the sub."
                      )}
                    </span>
                  </div>
                </div>
                <div className="si-popup__foot">
                  <div
                    className="si-btn si-btn__primary si-btn__primary--outline"
                    onClick={() => {
                      self.props.history.goBack();
                    }}
                  >
                    <span>{getTrans(transData, "cancel", "Cancel")}</span>
                  </div>
                  <div
                    className="si-btn si-btn__primary"
                    onClick={() => {
                      self.makeSubsPostcall();
                    }}
                  >
                    <span>{getTrans(transData, "confirm", "Confirm")}</span>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </>
    );
  }
}

export default withRouter(
  Consume(TeamDataHeader, [
    TransContext,
    TeamDataContext,
    PlayerListContext,
    ConstraintsContext,
    CompositionContext,
    ShowPopUpContext,
    FixturesContext,
    ShowToastContext,
    GamedaysContext,
    LoginContext,
    BoosterCardContext,
  ])
);
